export default {
	TABLE_TITLE: 'Shifts',
	EXPORT_CSV: 'Export CSV',
	REMOVE_SHIFTS_FROM_EMPLOYEE_TOOLTIP: 'Remove shifts from employee',
};
